var e="requestType",r="service",t="ticketsTerm",c="orderTicketId",i="comment",m="tariff";export{i as COMMENT,c as ORDER_TICKET_ID,e as REQUEST_TYPE,r as SERVICE_TYPE,m as TARIFF_TYPE,t as TICKETS_TERM};
